import { useMemo } from 'react';

export const useStatsCalculation = (trips) => {
  const stats = useMemo(() => {
    // Calcular contadores por estado
    const stateCounts = trips.reduce((acc, trip) => {
      acc[trip.state] = (acc[trip.state] || 0) + 1;
      return acc;
    }, {});

    // Calcular valores únicos
    const uniqueDrivers = new Set(trips.map(trip => trip.user_name)).size;
    const uniqueCarriers = new Set(trips.map(trip => trip.carrier_name)).size;
    const totalTrips = trips.length;

    // Gerar dados de tendência simples (simulados)
    const generateTrendData = (baseValue) => {
      const variance = Math.max(baseValue * 0.2, 5);
      return Array.from({ length: 30 }, (_, i) => {
        const factor = Math.sin(i * 0.2) * variance + baseValue;
        return Math.max(0, Math.round(factor + (Math.random() - 0.5) * variance * 0.5));
      });
    };

    // Calcular tendência baseada em comparação com média
    const calculateTrend = (current, baseline = 100) => {
      const difference = current - baseline;
      const percentageDiff = (difference / baseline) * 100;

      let trend;
      if (percentageDiff > 5) trend = 'up';
      else if (percentageDiff < -5) trend = 'down';
      else trend = 'neutral';

      return {
        trend,
        percentage: percentageDiff.toFixed(1) + '%'
      };
    };

    const tripsTrend = calculateTrend(totalTrips, 50);
    const driversTrend = calculateTrend(uniqueDrivers, 20);
    const completedTrend = calculateTrend(stateCounts.finished || 0, 30);

    return [
      {
        title: 'Viagens',
        value: totalTrips.toString(),
        interval: 'Hoje',
        trend: tripsTrend.trend,
        trendValue: tripsTrend.percentage,
        data: generateTrendData(totalTrips)
      },
      {
        title: 'Motoristas',
        value: uniqueDrivers.toString(),
        interval: 'Hoje',
        trend: driversTrend.trend,
        trendValue: driversTrend.percentage,
        data: generateTrendData(uniqueDrivers)
      },
      {
        title: 'Concluídas',
        value: (stateCounts.finished || 0).toString(),
        interval: 'Hoje',
        trend: completedTrend.trend,
        trendValue: completedTrend.percentage,
        data: generateTrendData(stateCounts.finished || 0)
      }
    ];
  }, [trips]);

  return stats;
}; 